// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ICountry {
    id: number;
    code: string;
    code2: string;
    displayValue: string;
    description: string;
    isReciprocity: boolean;
    sortOrder: number;
    active: boolean;
}

export class Country implements ICountry, IBaseType {
    public id: number;
    public code: string;
    public code2: string;
    public displayValue: string;
    public description: string;
    public isReciprocity: boolean;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns United States Country
	**/
    get US(): ICountry {
        return this.FromId(234);
    }
    /**
		Returns Afghanistan Country
	**/
    get AF(): ICountry {
        return this.FromId(1);
    }
    /**
		Returns Aland Islands Country
	**/
    get AX(): ICountry {
        return this.FromId(2);
    }
    /**
		Returns Albania Country
	**/
    get AL(): ICountry {
        return this.FromId(3);
    }
    /**
		Returns Algeria Country
	**/
    get DZ(): ICountry {
        return this.FromId(4);
    }
    /**
		Returns American Samoa including Swain Islands Country
	**/
    get AS(): ICountry {
        return this.FromId(254);
    }
    /**
		Returns Andorra Country
	**/
    get AD(): ICountry {
        return this.FromId(6);
    }
    /**
		Returns Angola Country
	**/
    get AO(): ICountry {
        return this.FromId(7);
    }
    /**
		Returns Anguilla Country
	**/
    get AI(): ICountry {
        return this.FromId(8);
    }
    /**
		Returns Antarctica Country
	**/
    get AQ(): ICountry {
        return this.FromId(9);
    }
    /**
		Returns Antigua And Barbuda Country
	**/
    get AG(): ICountry {
        return this.FromId(10);
    }
    /**
		Returns Argentina Country
	**/
    get AR(): ICountry {
        return this.FromId(11);
    }
    /**
		Returns Armenia Country
	**/
    get AM(): ICountry {
        return this.FromId(12);
    }
    /**
		Returns Aruba Country
	**/
    get AW(): ICountry {
        return this.FromId(13);
    }
    /**
		Returns Australia Country
	**/
    get AU(): ICountry {
        return this.FromId(14);
    }
    /**
		Returns Austria Country
	**/
    get AT(): ICountry {
        return this.FromId(15);
    }
    /**
		Returns Azerbaijan Country
	**/
    get AZ(): ICountry {
        return this.FromId(16);
    }
    /**
		Returns Bahama Islands Country
	**/
    get BS(): ICountry {
        return this.FromId(17);
    }
    /**
		Returns Bahrain Country
	**/
    get BH(): ICountry {
        return this.FromId(18);
    }
    /**
		Returns Bangladesh Country
	**/
    get BD(): ICountry {
        return this.FromId(19);
    }
    /**
		Returns Barbados Country
	**/
    get BB(): ICountry {
        return this.FromId(20);
    }
    /**
		Returns Belarus Country
	**/
    get BY(): ICountry {
        return this.FromId(21);
    }
    /**
		Returns Belgium Country
	**/
    get BE(): ICountry {
        return this.FromId(22);
    }
    /**
		Returns Belize Country
	**/
    get BZ(): ICountry {
        return this.FromId(23);
    }
    /**
		Returns Benin Country
	**/
    get BJ(): ICountry {
        return this.FromId(24);
    }
    /**
		Returns Bermuda Country
	**/
    get BM(): ICountry {
        return this.FromId(25);
    }
    /**
		Returns Bhutan Country
	**/
    get BT(): ICountry {
        return this.FromId(26);
    }
    /**
		Returns Bolivia Country
	**/
    get BO(): ICountry {
        return this.FromId(27);
    }
    /**
		Returns Bonaire Country
	**/
    get BQ(): ICountry {
        return this.FromId(28);
    }
    /**
		Returns Bosnia Country
	**/
    get BA(): ICountry {
        return this.FromId(29);
    }
    /**
		Returns Botswana Country
	**/
    get BW(): ICountry {
        return this.FromId(30);
    }
    /**
		Returns Bouvet Island Country
	**/
    get BV(): ICountry {
        return this.FromId(31);
    }
    /**
		Returns Brazil Country
	**/
    get BR(): ICountry {
        return this.FromId(32);
    }
    /**
		Returns British Indian Ocean Territory (?) Country
	**/
    get IO(): ICountry {
        return this.FromId(33);
    }
    /**
		Returns British Virgin Islands Country
	**/
    get VG(): ICountry {
        return this.FromId(34);
    }
    /**
		Returns Brunei Country
	**/
    get BN(): ICountry {
        return this.FromId(35);
    }
    /**
		Returns Bulgaria Country
	**/
    get BG(): ICountry {
        return this.FromId(36);
    }
    /**
		Returns Burkina Country
	**/
    get BF(): ICountry {
        return this.FromId(37);
    }
    /**
		Returns Burundi Country
	**/
    get BI(): ICountry {
        return this.FromId(38);
    }
    /**
		Returns Cambodia Country
	**/
    get KH(): ICountry {
        return this.FromId(39);
    }
    /**
		Returns Cameroon Country
	**/
    get CM(): ICountry {
        return this.FromId(40);
    }
    /**
		Returns Canada Country
	**/
    get CA(): ICountry {
        return this.FromId(41);
    }
    /**
		Returns Cape Verde Country
	**/
    get CV(): ICountry {
        return this.FromId(42);
    }
    /**
		Returns Ca'te D'lvoire Country
	**/
    get CI(): ICountry {
        return this.FromId(43);
    }
    /**
		Returns Cayman Islands Country
	**/
    get KY(): ICountry {
        return this.FromId(44);
    }
    /**
		Returns Central African Republic Country
	**/
    get CF(): ICountry {
        return this.FromId(45);
    }
    /**
		Returns Chad Country
	**/
    get TD(): ICountry {
        return this.FromId(46);
    }
    /**
		Returns Chile Country
	**/
    get CL(): ICountry {
        return this.FromId(47);
    }
    /**
		Returns China Country
	**/
    get CN(): ICountry {
        return this.FromId(48);
    }
    /**
		Returns Christmas Island Country
	**/
    get CX(): ICountry {
        return this.FromId(49);
    }
    /**
		Returns Cocos Islands Country
	**/
    get CC(): ICountry {
        return this.FromId(50);
    }
    /**
		Returns Columbia Country
	**/
    get CO(): ICountry {
        return this.FromId(51);
    }
    /**
		Returns Comoros Country
	**/
    get KM(): ICountry {
        return this.FromId(52);
    }
    /**
		Returns Congo Country
	**/
    get CG(): ICountry {
        return this.FromId(53);
    }
    /**
		Returns Cook Islands Country
	**/
    get CK(): ICountry {
        return this.FromId(54);
    }
    /**
		Returns Costa Rica Country
	**/
    get CR(): ICountry {
        return this.FromId(55);
    }
    /**
		Returns Croatia Country
	**/
    get HR(): ICountry {
        return this.FromId(56);
    }
    /**
		Returns Cuba Country
	**/
    get CU(): ICountry {
        return this.FromId(57);
    }
    /**
		Returns Curacao Country
	**/
    get CW(): ICountry {
        return this.FromId(58);
    }
    /**
		Returns Cyprus Country
	**/
    get CY(): ICountry {
        return this.FromId(59);
    }
    /**
		Returns Czech Republic Country
	**/
    get CZ(): ICountry {
        return this.FromId(60);
    }
    /**
		Returns Democratic Republic Of The Congo Country
	**/
    get CD(): ICountry {
        return this.FromId(61);
    }
    /**
		Returns Denmark Country
	**/
    get DK(): ICountry {
        return this.FromId(62);
    }
    /**
		Returns Djibouti Country
	**/
    get DJ(): ICountry {
        return this.FromId(63);
    }
    /**
		Returns Dominica Country
	**/
    get DM(): ICountry {
        return this.FromId(64);
    }
    /**
		Returns Dominican Rep Country
	**/
    get DO(): ICountry {
        return this.FromId(65);
    }
    /**
		Returns Ecuador Country
	**/
    get EC(): ICountry {
        return this.FromId(66);
    }
    /**
		Returns Egypt Country
	**/
    get EG(): ICountry {
        return this.FromId(67);
    }
    /**
		Returns El Salvador Country
	**/
    get SV(): ICountry {
        return this.FromId(68);
    }
    /**
		Returns Equatorial Guinea Country
	**/
    get GQ(): ICountry {
        return this.FromId(69);
    }
    /**
		Returns Eritrea Country
	**/
    get ER(): ICountry {
        return this.FromId(70);
    }
    /**
		Returns Estonia Country
	**/
    get EE(): ICountry {
        return this.FromId(71);
    }
    /**
		Returns Ethiopia Country
	**/
    get ET(): ICountry {
        return this.FromId(72);
    }
    /**
		Returns Falkland Islands (Malvinas) Country
	**/
    get FK(): ICountry {
        return this.FromId(73);
    }
    /**
		Returns Faroe Islands Country
	**/
    get FO(): ICountry {
        return this.FromId(74);
    }
    /**
		Returns Federated States of Micronesia Country
	**/
    get FM(): ICountry {
        return this.FromId(255);
    }
    /**
		Returns Fiji Country
	**/
    get FJ(): ICountry {
        return this.FromId(75);
    }
    /**
		Returns Finland Country
	**/
    get FI(): ICountry {
        return this.FromId(76);
    }
    /**
		Returns France Country
	**/
    get FR(): ICountry {
        return this.FromId(77);
    }
    /**
		Returns French Guiana Country
	**/
    get GF(): ICountry {
        return this.FromId(78);
    }
    /**
		Returns French Polynesia Country
	**/
    get PF(): ICountry {
        return this.FromId(79);
    }
    /**
		Returns French Southern Territories Country
	**/
    get TF(): ICountry {
        return this.FromId(80);
    }
    /**
		Returns Gabon Country
	**/
    get GA(): ICountry {
        return this.FromId(81);
    }
    /**
		Returns Gambia Country
	**/
    get GM(): ICountry {
        return this.FromId(82);
    }
    /**
		Returns Georgia Country
	**/
    get GE(): ICountry {
        return this.FromId(83);
    }
    /**
		Returns Germany Country
	**/
    get DE(): ICountry {
        return this.FromId(84);
    }
    /**
		Returns Ghana Country
	**/
    get GH(): ICountry {
        return this.FromId(85);
    }
    /**
		Returns Gibraltar Country
	**/
    get GI(): ICountry {
        return this.FromId(86);
    }
    /**
		Returns Greece Country
	**/
    get GR(): ICountry {
        return this.FromId(87);
    }
    /**
		Returns Greenland Country
	**/
    get GL(): ICountry {
        return this.FromId(88);
    }
    /**
		Returns Grenada Country
	**/
    get GD(): ICountry {
        return this.FromId(89);
    }
    /**
		Returns Guadeloupe Country
	**/
    get GP(): ICountry {
        return this.FromId(90);
    }
    /**
		Returns Guam Country
	**/
    get GU(): ICountry {
        return this.FromId(256);
    }
    /**
		Returns Guatemala Country
	**/
    get GT(): ICountry {
        return this.FromId(92);
    }
    /**
		Returns Guernsey Country
	**/
    get GG(): ICountry {
        return this.FromId(93);
    }
    /**
		Returns Guinea Country
	**/
    get GN(): ICountry {
        return this.FromId(94);
    }
    /**
		Returns Guinea Bissau Country
	**/
    get GW(): ICountry {
        return this.FromId(95);
    }
    /**
		Returns Guyana Country
	**/
    get GY(): ICountry {
        return this.FromId(96);
    }
    /**
		Returns Haiti Country
	**/
    get HT(): ICountry {
        return this.FromId(97);
    }
    /**
		Returns Heard Island And McDonald Islands Country
	**/
    get HM(): ICountry {
        return this.FromId(98);
    }
    /**
		Returns Honduras Country
	**/
    get HN(): ICountry {
        return this.FromId(99);
    }
    /**
		Returns Hong Kong Country
	**/
    get HK(): ICountry {
        return this.FromId(100);
    }
    /**
		Returns Hungary Country
	**/
    get HU(): ICountry {
        return this.FromId(101);
    }
    /**
		Returns Iceland Country
	**/
    get IS(): ICountry {
        return this.FromId(102);
    }
    /**
		Returns India Country
	**/
    get IN(): ICountry {
        return this.FromId(103);
    }
    /**
		Returns Indonesia Country
	**/
    get ID(): ICountry {
        return this.FromId(104);
    }
    /**
		Returns Iran Country
	**/
    get IR(): ICountry {
        return this.FromId(105);
    }
    /**
		Returns Iraq Country
	**/
    get IQ(): ICountry {
        return this.FromId(106);
    }
    /**
		Returns Ireland Country
	**/
    get IE(): ICountry {
        return this.FromId(107);
    }
    /**
		Returns Isle Of Man Country
	**/
    get IM(): ICountry {
        return this.FromId(108);
    }
    /**
		Returns Israel Country
	**/
    get IL(): ICountry {
        return this.FromId(109);
    }
    /**
		Returns Italy Country
	**/
    get IT(): ICountry {
        return this.FromId(110);
    }
    /**
		Returns Jamaica Country
	**/
    get JM(): ICountry {
        return this.FromId(111);
    }
    /**
		Returns Japan Country
	**/
    get JP(): ICountry {
        return this.FromId(112);
    }
    /**
		Returns Jersey Country
	**/
    get JE(): ICountry {
        return this.FromId(113);
    }
    /**
		Returns Jordan Country
	**/
    get JO(): ICountry {
        return this.FromId(114);
    }
    /**
		Returns Kazakhstan Country
	**/
    get KZ(): ICountry {
        return this.FromId(115);
    }
    /**
		Returns Kenya Country
	**/
    get KE(): ICountry {
        return this.FromId(116);
    }
    /**
		Returns Kiribati Country
	**/
    get KI(): ICountry {
        return this.FromId(117);
    }
    /**
		Returns Korea (Democratic People's Republic Of) Country
	**/
    get KP(): ICountry {
        return this.FromId(118);
    }
    /**
		Returns Korea (Republic Of) Country
	**/
    get KR(): ICountry {
        return this.FromId(119);
    }
    /**
		Returns Kuwait Country
	**/
    get KW(): ICountry {
        return this.FromId(120);
    }
    /**
		Returns Kyrgyzstan Country
	**/
    get KG(): ICountry {
        return this.FromId(121);
    }
    /**
		Returns Laos Country
	**/
    get LA(): ICountry {
        return this.FromId(122);
    }
    /**
		Returns Latvia Country
	**/
    get LV(): ICountry {
        return this.FromId(123);
    }
    /**
		Returns Lebanon Country
	**/
    get LB(): ICountry {
        return this.FromId(124);
    }
    /**
		Returns Lesotho Country
	**/
    get LS(): ICountry {
        return this.FromId(125);
    }
    /**
		Returns Liberia Country
	**/
    get LR(): ICountry {
        return this.FromId(126);
    }
    /**
		Returns Libya Country
	**/
    get LY(): ICountry {
        return this.FromId(127);
    }
    /**
		Returns Liechtenstein Country
	**/
    get LI(): ICountry {
        return this.FromId(128);
    }
    /**
		Returns Lithuania Country
	**/
    get LT(): ICountry {
        return this.FromId(129);
    }
    /**
		Returns Luxembourg Country
	**/
    get LU(): ICountry {
        return this.FromId(130);
    }
    /**
		Returns Macao Country
	**/
    get MO(): ICountry {
        return this.FromId(131);
    }
    /**
		Returns Macedonia Country
	**/
    get MK(): ICountry {
        return this.FromId(132);
    }
    /**
		Returns Madagascar Country
	**/
    get MG(): ICountry {
        return this.FromId(133);
    }
    /**
		Returns Malawi Country
	**/
    get MW(): ICountry {
        return this.FromId(134);
    }
    /**
		Returns Malaysia Country
	**/
    get MY(): ICountry {
        return this.FromId(135);
    }
    /**
		Returns Maldives Country
	**/
    get MV(): ICountry {
        return this.FromId(136);
    }
    /**
		Returns Mali Country
	**/
    get ML(): ICountry {
        return this.FromId(137);
    }
    /**
		Returns Malta Country
	**/
    get MT(): ICountry {
        return this.FromId(138);
    }
    /**
		Returns Marshall Islands Country
	**/
    get MH(): ICountry {
        return this.FromId(257);
    }
    /**
		Returns Martinique Country
	**/
    get MQ(): ICountry {
        return this.FromId(140);
    }
    /**
		Returns Mauritania Country
	**/
    get MR(): ICountry {
        return this.FromId(141);
    }
    /**
		Returns Mauritius Country
	**/
    get MU(): ICountry {
        return this.FromId(142);
    }
    /**
		Returns Mayotte Country
	**/
    get YT(): ICountry {
        return this.FromId(143);
    }
    /**
		Returns Mexico Country
	**/
    get MX(): ICountry {
        return this.FromId(144);
    }
    /**
		Returns Moldova Country
	**/
    get MD(): ICountry {
        return this.FromId(146);
    }
    /**
		Returns Monaco Country
	**/
    get MC(): ICountry {
        return this.FromId(147);
    }
    /**
		Returns Mongolia Country
	**/
    get MN(): ICountry {
        return this.FromId(148);
    }
    /**
		Returns Montenegro Country
	**/
    get ME(): ICountry {
        return this.FromId(149);
    }
    /**
		Returns Montserrat Country
	**/
    get MS(): ICountry {
        return this.FromId(150);
    }
    /**
		Returns Morocco Country
	**/
    get MA(): ICountry {
        return this.FromId(151);
    }
    /**
		Returns Mozambique Country
	**/
    get MZ(): ICountry {
        return this.FromId(152);
    }
    /**
		Returns Myanmar Country
	**/
    get MM(): ICountry {
        return this.FromId(153);
    }
    /**
		Returns Namibia Country
	**/
    get NA(): ICountry {
        return this.FromId(154);
    }
    /**
		Returns Nauru Country
	**/
    get NR(): ICountry {
        return this.FromId(155);
    }
    /**
		Returns Nepal Country
	**/
    get NP(): ICountry {
        return this.FromId(156);
    }
    /**
		Returns Netherlands Country
	**/
    get NL(): ICountry {
        return this.FromId(157);
    }
    /**
		Returns New Caledonia Country
	**/
    get NC(): ICountry {
        return this.FromId(158);
    }
    /**
		Returns New Zealand Country
	**/
    get NZ(): ICountry {
        return this.FromId(159);
    }
    /**
		Returns Nicaragua Country
	**/
    get NI(): ICountry {
        return this.FromId(160);
    }
    /**
		Returns Niger Country
	**/
    get NE(): ICountry {
        return this.FromId(161);
    }
    /**
		Returns Nigeria Country
	**/
    get NG(): ICountry {
        return this.FromId(162);
    }
    /**
		Returns Niue Country
	**/
    get NU(): ICountry {
        return this.FromId(163);
    }
    /**
		Returns Norfolk Island Country
	**/
    get NF(): ICountry {
        return this.FromId(164);
    }
    /**
		Returns Northern Mariana Island Country
	**/
    get MP(): ICountry {
        return this.FromId(258);
    }
    /**
		Returns Norway Country
	**/
    get NO(): ICountry {
        return this.FromId(166);
    }
    /**
		Returns Oman Country
	**/
    get OM(): ICountry {
        return this.FromId(167);
    }
    /**
		Returns Pakistan Country
	**/
    get PK(): ICountry {
        return this.FromId(168);
    }
    /**
		Returns Palau Country
	**/
    get PW(): ICountry {
        return this.FromId(259);
    }
    /**
		Returns Palestine Country
	**/
    get PS(): ICountry {
        return this.FromId(170);
    }
    /**
		Returns Panama Country
	**/
    get PA(): ICountry {
        return this.FromId(171);
    }
    /**
		Returns Papua New Guinea Country
	**/
    get PG(): ICountry {
        return this.FromId(172);
    }
    /**
		Returns Paraguay Country
	**/
    get PY(): ICountry {
        return this.FromId(173);
    }
    /**
		Returns Peru Country
	**/
    get PE(): ICountry {
        return this.FromId(174);
    }
    /**
		Returns Philippines Island Country
	**/
    get PH(): ICountry {
        return this.FromId(175);
    }
    /**
		Returns Pitcairn Country
	**/
    get PN(): ICountry {
        return this.FromId(176);
    }
    /**
		Returns Poland Country
	**/
    get PL(): ICountry {
        return this.FromId(177);
    }
    /**
		Returns Portugal Country
	**/
    get PT(): ICountry {
        return this.FromId(178);
    }
    /**
		Returns Puerto Rico Country
	**/
    get PR(): ICountry {
        return this.FromId(260);
    }
    /**
		Returns Qatar Country
	**/
    get QA(): ICountry {
        return this.FromId(180);
    }
    /**
		Returns Reunion Country
	**/
    get RE(): ICountry {
        return this.FromId(181);
    }
    /**
		Returns Romania Country
	**/
    get RO(): ICountry {
        return this.FromId(182);
    }
    /**
		Returns Russia Country
	**/
    get RU(): ICountry {
        return this.FromId(183);
    }
    /**
		Returns Rwanda Country
	**/
    get RW(): ICountry {
        return this.FromId(184);
    }
    /**
		Returns Saint Barthelemy Country
	**/
    get BL(): ICountry {
        return this.FromId(185);
    }
    /**
		Returns Saint Helena Country
	**/
    get SH(): ICountry {
        return this.FromId(186);
    }
    /**
		Returns Saint Kitts And Nevis Country
	**/
    get KN(): ICountry {
        return this.FromId(187);
    }
    /**
		Returns Saint Martin (French Part) Country
	**/
    get MF(): ICountry {
        return this.FromId(188);
    }
    /**
		Returns Saint Pierre And Miquelon Country
	**/
    get PM(): ICountry {
        return this.FromId(189);
    }
    /**
		Returns San Marino Country
	**/
    get SM(): ICountry {
        return this.FromId(190);
    }
    /**
		Returns Sao Tome And Principe Country
	**/
    get ST(): ICountry {
        return this.FromId(191);
    }
    /**
		Returns Saudi Arabia Country
	**/
    get SA(): ICountry {
        return this.FromId(192);
    }
    /**
		Returns Senegal Country
	**/
    get SN(): ICountry {
        return this.FromId(193);
    }
    /**
		Returns Serbia Country
	**/
    get RS(): ICountry {
        return this.FromId(194);
    }
    /**
		Returns Seychelles Country
	**/
    get SC(): ICountry {
        return this.FromId(195);
    }
    /**
		Returns Sierra Leone Country
	**/
    get SL(): ICountry {
        return this.FromId(196);
    }
    /**
		Returns Singapore Country
	**/
    get SG(): ICountry {
        return this.FromId(197);
    }
    /**
		Returns Sint Maarten (Dutch Part) Country
	**/
    get SX(): ICountry {
        return this.FromId(198);
    }
    /**
		Returns Slovakia Country
	**/
    get SK(): ICountry {
        return this.FromId(199);
    }
    /**
		Returns Slovenia Country
	**/
    get SI(): ICountry {
        return this.FromId(200);
    }
    /**
		Returns Solomon Islands Country
	**/
    get SB(): ICountry {
        return this.FromId(201);
    }
    /**
		Returns Somalia Country
	**/
    get SO(): ICountry {
        return this.FromId(202);
    }
    /**
		Returns South Africa Country
	**/
    get ZA(): ICountry {
        return this.FromId(203);
    }
    /**
		Returns South Georgia And The South Sandwich Islands Country
	**/
    get GS(): ICountry {
        return this.FromId(204);
    }
    /**
		Returns South Sudan Country
	**/
    get SS(): ICountry {
        return this.FromId(205);
    }
    /**
		Returns Spain Country
	**/
    get ES(): ICountry {
        return this.FromId(206);
    }
    /**
		Returns Sri Lanka Country
	**/
    get LK(): ICountry {
        return this.FromId(207);
    }
    /**
		Returns St Vincent And The Grenadines Country
	**/
    get VC(): ICountry {
        return this.FromId(208);
    }
    /**
		Returns St. Lucia Country
	**/
    get LC(): ICountry {
        return this.FromId(209);
    }
    /**
		Returns Sudan Country
	**/
    get SD(): ICountry {
        return this.FromId(210);
    }
    /**
		Returns Suriname Country
	**/
    get SR(): ICountry {
        return this.FromId(211);
    }
    /**
		Returns Svalbard And Jan Mayen Country
	**/
    get SJ(): ICountry {
        return this.FromId(212);
    }
    /**
		Returns Swaziland Country
	**/
    get SZ(): ICountry {
        return this.FromId(213);
    }
    /**
		Returns Sweden Country
	**/
    get SE(): ICountry {
        return this.FromId(214);
    }
    /**
		Returns Switzerland Country
	**/
    get CH(): ICountry {
        return this.FromId(215);
    }
    /**
		Returns Syria Country
	**/
    get SY(): ICountry {
        return this.FromId(216);
    }
    /**
		Returns Taiwan Country
	**/
    get TW(): ICountry {
        return this.FromId(217);
    }
    /**
		Returns Tajikistan Country
	**/
    get TJ(): ICountry {
        return this.FromId(218);
    }
    /**
		Returns Tanzania Country
	**/
    get TZ(): ICountry {
        return this.FromId(219);
    }
    /**
		Returns Thailand Country
	**/
    get TH(): ICountry {
        return this.FromId(220);
    }
    /**
		Returns Timor-Leste Country
	**/
    get TL(): ICountry {
        return this.FromId(221);
    }
    /**
		Returns Togo Country
	**/
    get TG(): ICountry {
        return this.FromId(222);
    }
    /**
		Returns Tokelau Country
	**/
    get TK(): ICountry {
        return this.FromId(223);
    }
    /**
		Returns Tonga Country
	**/
    get TO(): ICountry {
        return this.FromId(224);
    }
    /**
		Returns Tunisia Country
	**/
    get TN(): ICountry {
        return this.FromId(225);
    }
    /**
		Returns Turkey Country
	**/
    get TR(): ICountry {
        return this.FromId(226);
    }
    /**
		Returns Turkmenistan Country
	**/
    get TM(): ICountry {
        return this.FromId(227);
    }
    /**
		Returns Turks And Caicos Islands Country
	**/
    get TC(): ICountry {
        return this.FromId(228);
    }
    /**
		Returns Tuvalu Country
	**/
    get TV(): ICountry {
        return this.FromId(229);
    }
    /**
		Returns Uganda Country
	**/
    get UG(): ICountry {
        return this.FromId(230);
    }
    /**
		Returns Ukraine Country
	**/
    get UA(): ICountry {
        return this.FromId(231);
    }
    /**
		Returns United Arab Emirates Country
	**/
    get AE(): ICountry {
        return this.FromId(232);
    }
    /**
		Returns United Kingdom Country
	**/
    get GB(): ICountry {
        return this.FromId(233);
    }
    /**
		Returns Unknown Country
	**/
    get UK(): ICountry {
        return this.FromId(236);
    }
    /**
		Returns Uruguay Country
	**/
    get UY(): ICountry {
        return this.FromId(237);
    }
    /**
		Returns Uzbekistan Country
	**/
    get UZ(): ICountry {
        return this.FromId(239);
    }
    /**
		Returns Vanuatu Country
	**/
    get VU(): ICountry {
        return this.FromId(240);
    }
    /**
		Returns Vatican City Country
	**/
    get VA(): ICountry {
        return this.FromId(241);
    }
    /**
		Returns Venezuela Country
	**/
    get VE(): ICountry {
        return this.FromId(242);
    }
    /**
		Returns Vietnam Country
	**/
    get VN(): ICountry {
        return this.FromId(243);
    }
    /**
		Returns Virgin Islands Country
	**/
    get VI(): ICountry {
        return this.FromId(261);
    }
    /**
		Returns Wallis And Futuna Country
	**/
    get WF(): ICountry {
        return this.FromId(244);
    }
    /**
		Returns Western Sahara Country
	**/
    get EH(): ICountry {
        return this.FromId(245);
    }
    /**
		Returns Western Samoa Country
	**/
    get WS(): ICountry {
        return this.FromId(246);
    }
    /**
		Returns Yemen Country
	**/
    get YE(): ICountry {
        return this.FromId(247);
    }
    /**
		Returns Zambia Country
	**/
    get ZM(): ICountry {
        return this.FromId(248);
    }
    /**
		Returns Zimbabwe Country
	**/
    get ZW(): ICountry {
        return this.FromId(249);
    }
    /**
		Returns Unknown Country
	**/
    get UW(): ICountry {
        return this.FromId(253);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('234', { id: 234, code: 'US', code2: 'USA', displayValue: 'United States', description: 'United States', isReciprocity: false, sortOrder: 1, active: true });
        this._dictionary.add('1', { id: 1, code: 'AF', code2: 'AFG', displayValue: 'Afghanistan', description: 'Afghanistan', isReciprocity: false, sortOrder: 5, active: true });
        this._dictionary.add('2', { id: 2, code: 'AX', code2: 'ALA', displayValue: 'Aland Islands', description: 'Aland Islands', isReciprocity: false, sortOrder: 10, active: true });
        this._dictionary.add('3', { id: 3, code: 'AL', code2: 'ALB', displayValue: 'Albania', description: 'Albania', isReciprocity: false, sortOrder: 15, active: true });
        this._dictionary.add('4', { id: 4, code: 'DZ', code2: 'DZA', displayValue: 'Algeria', description: 'Algeria', isReciprocity: false, sortOrder: 20, active: true });
        this._dictionary.add('254', { id: 254, code: 'AS', code2: 'ASM', displayValue: 'American Samoa including Swain Islands', description: 'American Samoa including Swain Islands', isReciprocity: false, sortOrder: 22, active: true });
        this._dictionary.add('6', { id: 6, code: 'AD', code2: 'AND', displayValue: 'Andorra', description: 'Andorra', isReciprocity: false, sortOrder: 25, active: true });
        this._dictionary.add('7', { id: 7, code: 'AO', code2: 'AGO', displayValue: 'Angola', description: 'Angola', isReciprocity: false, sortOrder: 30, active: true });
        this._dictionary.add('8', { id: 8, code: 'AI', code2: 'AIA', displayValue: 'Anguilla', description: 'Anguilla', isReciprocity: false, sortOrder: 35, active: true });
        this._dictionary.add('9', { id: 9, code: 'AQ', code2: 'ATA', displayValue: 'Antarctica', description: 'Antarctica', isReciprocity: false, sortOrder: 40, active: true });
        this._dictionary.add('10', { id: 10, code: 'AG', code2: 'ATG', displayValue: 'Antigua And Barbuda', description: 'Antigua And Barbuda', isReciprocity: false, sortOrder: 45, active: true });
        this._dictionary.add('11', { id: 11, code: 'AR', code2: 'ARG', displayValue: 'Argentina', description: 'Argentina', isReciprocity: false, sortOrder: 50, active: true });
        this._dictionary.add('12', { id: 12, code: 'AM', code2: 'ARM', displayValue: 'Armenia', description: 'Armenia', isReciprocity: false, sortOrder: 55, active: true });
        this._dictionary.add('13', { id: 13, code: 'AW', code2: 'ABW', displayValue: 'Aruba', description: 'Aruba', isReciprocity: false, sortOrder: 60, active: true });
        this._dictionary.add('14', { id: 14, code: 'AU', code2: 'AUS', displayValue: 'Australia', description: 'Australia', isReciprocity: false, sortOrder: 65, active: true });
        this._dictionary.add('15', { id: 15, code: 'AT', code2: 'AUT', displayValue: 'Austria', description: 'Austria', isReciprocity: false, sortOrder: 70, active: true });
        this._dictionary.add('16', { id: 16, code: 'AZ', code2: 'AZE', displayValue: 'Azerbaijan', description: 'Azerbaijan', isReciprocity: false, sortOrder: 75, active: true });
        this._dictionary.add('17', { id: 17, code: 'BS', code2: 'BHS', displayValue: 'Bahama Islands', description: 'Bahama Islands', isReciprocity: false, sortOrder: 80, active: true });
        this._dictionary.add('18', { id: 18, code: 'BH', code2: 'BHR', displayValue: 'Bahrain', description: 'Bahrain', isReciprocity: false, sortOrder: 85, active: true });
        this._dictionary.add('19', { id: 19, code: 'BD', code2: 'BGD', displayValue: 'Bangladesh', description: 'Bangladesh', isReciprocity: false, sortOrder: 90, active: true });
        this._dictionary.add('20', { id: 20, code: 'BB', code2: 'BRB', displayValue: 'Barbados', description: 'Barbados', isReciprocity: false, sortOrder: 95, active: true });
        this._dictionary.add('21', { id: 21, code: 'BY', code2: 'BLR', displayValue: 'Belarus', description: 'Belarus', isReciprocity: false, sortOrder: 100, active: true });
        this._dictionary.add('22', { id: 22, code: 'BE', code2: 'BEL', displayValue: 'Belgium', description: 'Belgium', isReciprocity: false, sortOrder: 105, active: true });
        this._dictionary.add('23', { id: 23, code: 'BZ', code2: 'BLZ', displayValue: 'Belize', description: 'Belize', isReciprocity: false, sortOrder: 110, active: true });
        this._dictionary.add('24', { id: 24, code: 'BJ', code2: 'BEN', displayValue: 'Benin', description: 'Benin', isReciprocity: false, sortOrder: 115, active: true });
        this._dictionary.add('25', { id: 25, code: 'BM', code2: 'BMU', displayValue: 'Bermuda', description: 'Bermuda', isReciprocity: false, sortOrder: 120, active: true });
        this._dictionary.add('26', { id: 26, code: 'BT', code2: 'BTN', displayValue: 'Bhutan', description: 'Bhutan', isReciprocity: false, sortOrder: 125, active: true });
        this._dictionary.add('27', { id: 27, code: 'BO', code2: 'BOL', displayValue: 'Bolivia', description: 'Bolivia', isReciprocity: false, sortOrder: 130, active: true });
        this._dictionary.add('28', { id: 28, code: 'BQ', code2: 'BES', displayValue: 'Bonaire', description: 'Bonaire', isReciprocity: false, sortOrder: 135, active: true });
        this._dictionary.add('29', { id: 29, code: 'BA', code2: 'BIH', displayValue: 'Bosnia', description: 'Bosnia', isReciprocity: false, sortOrder: 140, active: true });
        this._dictionary.add('30', { id: 30, code: 'BW', code2: 'BWA', displayValue: 'Botswana', description: 'Botswana', isReciprocity: false, sortOrder: 145, active: true });
        this._dictionary.add('31', { id: 31, code: 'BV', code2: 'BVT', displayValue: 'Bouvet Island', description: 'Bouvet Island', isReciprocity: false, sortOrder: 150, active: true });
        this._dictionary.add('32', { id: 32, code: 'BR', code2: 'BRA', displayValue: 'Brazil', description: 'Brazil', isReciprocity: false, sortOrder: 155, active: true });
        this._dictionary.add('33', { id: 33, code: 'IO', code2: 'IOT', displayValue: 'British Indian Ocean Territory (?)', description: 'British Indian Ocean Territory (?)', isReciprocity: false, sortOrder: 160, active: true });
        this._dictionary.add('34', { id: 34, code: 'VG', code2: 'VGB', displayValue: 'British Virgin Islands', description: 'British Virgin Islands', isReciprocity: false, sortOrder: 165, active: true });
        this._dictionary.add('35', { id: 35, code: 'BN', code2: 'BRN', displayValue: 'Brunei', description: 'Brunei', isReciprocity: false, sortOrder: 170, active: true });
        this._dictionary.add('36', { id: 36, code: 'BG', code2: 'BGR', displayValue: 'Bulgaria', description: 'Bulgaria', isReciprocity: false, sortOrder: 175, active: true });
        this._dictionary.add('37', { id: 37, code: 'BF', code2: 'BFA', displayValue: 'Burkina', description: 'Burkina', isReciprocity: false, sortOrder: 180, active: true });
        this._dictionary.add('38', { id: 38, code: 'BI', code2: 'BDI', displayValue: 'Burundi', description: 'Burundi', isReciprocity: false, sortOrder: 185, active: true });
        this._dictionary.add('39', { id: 39, code: 'KH', code2: 'KHM', displayValue: 'Cambodia', description: 'Cambodia', isReciprocity: false, sortOrder: 190, active: true });
        this._dictionary.add('40', { id: 40, code: 'CM', code2: 'CMR', displayValue: 'Cameroon', description: 'Cameroon', isReciprocity: false, sortOrder: 195, active: true });
        this._dictionary.add('41', { id: 41, code: 'CA', code2: 'CAN', displayValue: 'Canada', description: 'Canada', isReciprocity: false, sortOrder: 200, active: true });
        this._dictionary.add('42', { id: 42, code: 'CV', code2: 'CPV', displayValue: 'Cape Verde', description: 'Cape Verde', isReciprocity: false, sortOrder: 205, active: true });
        this._dictionary.add('43', { id: 43, code: 'CI', code2: 'CIV', displayValue: 'Ca\'te D\'lvoire', description: 'Ca\'te D\'lvoire', isReciprocity: false, sortOrder: 210, active: true });
        this._dictionary.add('44', { id: 44, code: 'KY', code2: 'CYM', displayValue: 'Cayman Islands', description: 'Cayman Islands', isReciprocity: false, sortOrder: 215, active: true });
        this._dictionary.add('45', { id: 45, code: 'CF', code2: 'CAF', displayValue: 'Central African Republic', description: 'Central African Republic', isReciprocity: false, sortOrder: 220, active: true });
        this._dictionary.add('46', { id: 46, code: 'TD', code2: 'TCD', displayValue: 'Chad', description: 'Chad', isReciprocity: false, sortOrder: 225, active: true });
        this._dictionary.add('47', { id: 47, code: 'CL', code2: 'CHL', displayValue: 'Chile', description: 'Chile', isReciprocity: false, sortOrder: 230, active: true });
        this._dictionary.add('48', { id: 48, code: 'CN', code2: 'CHN', displayValue: 'China', description: 'China', isReciprocity: false, sortOrder: 235, active: true });
        this._dictionary.add('49', { id: 49, code: 'CX', code2: 'CXR', displayValue: 'Christmas Island', description: 'Christmas Island', isReciprocity: false, sortOrder: 240, active: true });
        this._dictionary.add('50', { id: 50, code: 'CC', code2: 'CCK', displayValue: 'Cocos Islands', description: 'Cocos Islands', isReciprocity: false, sortOrder: 245, active: true });
        this._dictionary.add('51', { id: 51, code: 'CO', code2: 'COL', displayValue: 'Columbia', description: 'Columbia', isReciprocity: false, sortOrder: 250, active: true });
        this._dictionary.add('52', { id: 52, code: 'KM', code2: 'COM', displayValue: 'Comoros', description: 'Comoros', isReciprocity: false, sortOrder: 255, active: true });
        this._dictionary.add('53', { id: 53, code: 'CG', code2: 'COG', displayValue: 'Congo', description: 'Congo', isReciprocity: false, sortOrder: 260, active: true });
        this._dictionary.add('54', { id: 54, code: 'CK', code2: 'COK', displayValue: 'Cook Islands', description: 'Cook Islands', isReciprocity: false, sortOrder: 265, active: true });
        this._dictionary.add('55', { id: 55, code: 'CR', code2: 'CRI', displayValue: 'Costa Rica', description: 'Costa Rica', isReciprocity: false, sortOrder: 270, active: true });
        this._dictionary.add('56', { id: 56, code: 'HR', code2: 'HRV', displayValue: 'Croatia', description: 'Croatia', isReciprocity: false, sortOrder: 275, active: true });
        this._dictionary.add('57', { id: 57, code: 'CU', code2: 'CUB', displayValue: 'Cuba', description: 'Cuba', isReciprocity: false, sortOrder: 280, active: true });
        this._dictionary.add('58', { id: 58, code: 'CW', code2: 'CUW', displayValue: 'Curacao', description: 'Curacao', isReciprocity: false, sortOrder: 285, active: true });
        this._dictionary.add('59', { id: 59, code: 'CY', code2: 'CYP', displayValue: 'Cyprus', description: 'Cyprus', isReciprocity: false, sortOrder: 290, active: true });
        this._dictionary.add('60', { id: 60, code: 'CZ', code2: 'CZE', displayValue: 'Czech Republic', description: 'Czech Republic', isReciprocity: false, sortOrder: 295, active: true });
        this._dictionary.add('61', { id: 61, code: 'CD', code2: 'COD', displayValue: 'Democratic Republic Of The Congo', description: 'Democratic Republic Of The Congo', isReciprocity: false, sortOrder: 300, active: true });
        this._dictionary.add('62', { id: 62, code: 'DK', code2: 'DNK', displayValue: 'Denmark', description: 'Denmark', isReciprocity: false, sortOrder: 305, active: true });
        this._dictionary.add('63', { id: 63, code: 'DJ', code2: 'DJI', displayValue: 'Djibouti', description: 'Djibouti', isReciprocity: false, sortOrder: 310, active: true });
        this._dictionary.add('64', { id: 64, code: 'DM', code2: 'DMA', displayValue: 'Dominica', description: 'Dominica', isReciprocity: false, sortOrder: 315, active: true });
        this._dictionary.add('65', { id: 65, code: 'DO', code2: 'DOM', displayValue: 'Dominican Rep', description: 'Dominican Rep', isReciprocity: false, sortOrder: 320, active: true });
        this._dictionary.add('66', { id: 66, code: 'EC', code2: 'ECU', displayValue: 'Ecuador', description: 'Ecuador', isReciprocity: false, sortOrder: 325, active: true });
        this._dictionary.add('67', { id: 67, code: 'EG', code2: 'EGY', displayValue: 'Egypt', description: 'Egypt', isReciprocity: false, sortOrder: 330, active: true });
        this._dictionary.add('68', { id: 68, code: 'SV', code2: 'SLV', displayValue: 'El Salvador', description: 'El Salvador', isReciprocity: false, sortOrder: 335, active: true });
        this._dictionary.add('69', { id: 69, code: 'GQ', code2: 'GNQ', displayValue: 'Equatorial Guinea', description: 'Equatorial Guinea', isReciprocity: false, sortOrder: 340, active: true });
        this._dictionary.add('70', { id: 70, code: 'ER', code2: 'ERI', displayValue: 'Eritrea', description: 'Eritrea', isReciprocity: false, sortOrder: 345, active: true });
        this._dictionary.add('71', { id: 71, code: 'EE', code2: 'EST', displayValue: 'Estonia', description: 'Estonia', isReciprocity: false, sortOrder: 350, active: true });
        this._dictionary.add('72', { id: 72, code: 'ET', code2: 'ETH', displayValue: 'Ethiopia', description: 'Ethiopia', isReciprocity: false, sortOrder: 355, active: true });
        this._dictionary.add('73', { id: 73, code: 'FK', code2: 'FLK', displayValue: 'Falkland Islands (Malvinas)', description: 'Falkland Islands (Malvinas)', isReciprocity: false, sortOrder: 360, active: true });
        this._dictionary.add('74', { id: 74, code: 'FO', code2: 'FRO', displayValue: 'Faroe Islands', description: 'Faroe Islands', isReciprocity: false, sortOrder: 365, active: true });
        this._dictionary.add('255', { id: 255, code: 'FM', code2: 'FSM', displayValue: 'Federated States of Micronesia', description: 'Federated States of Micronesia', isReciprocity: false, sortOrder: 367, active: true });
        this._dictionary.add('75', { id: 75, code: 'FJ', code2: 'FJI', displayValue: 'Fiji', description: 'Fiji', isReciprocity: false, sortOrder: 370, active: true });
        this._dictionary.add('76', { id: 76, code: 'FI', code2: 'FIN', displayValue: 'Finland', description: 'Finland', isReciprocity: false, sortOrder: 375, active: true });
        this._dictionary.add('77', { id: 77, code: 'FR', code2: 'FRA', displayValue: 'France', description: 'France', isReciprocity: false, sortOrder: 380, active: true });
        this._dictionary.add('78', { id: 78, code: 'GF', code2: 'GUF', displayValue: 'French Guiana', description: 'French Guiana', isReciprocity: false, sortOrder: 385, active: true });
        this._dictionary.add('79', { id: 79, code: 'PF', code2: 'PYF', displayValue: 'French Polynesia', description: 'French Polynesia', isReciprocity: false, sortOrder: 390, active: true });
        this._dictionary.add('80', { id: 80, code: 'TF', code2: 'ATF', displayValue: 'French Southern Territories', description: 'French Southern Territories', isReciprocity: false, sortOrder: 395, active: true });
        this._dictionary.add('81', { id: 81, code: 'GA', code2: 'GAB', displayValue: 'Gabon', description: 'Gabon', isReciprocity: false, sortOrder: 400, active: true });
        this._dictionary.add('82', { id: 82, code: 'GM', code2: 'GMB', displayValue: 'Gambia', description: 'Gambia', isReciprocity: false, sortOrder: 405, active: true });
        this._dictionary.add('83', { id: 83, code: 'GE', code2: 'GEO', displayValue: 'Georgia', description: 'Georgia', isReciprocity: false, sortOrder: 410, active: true });
        this._dictionary.add('84', { id: 84, code: 'DE', code2: 'DEU', displayValue: 'Germany', description: 'Germany', isReciprocity: false, sortOrder: 415, active: true });
        this._dictionary.add('85', { id: 85, code: 'GH', code2: 'GHA', displayValue: 'Ghana', description: 'Ghana', isReciprocity: false, sortOrder: 420, active: true });
        this._dictionary.add('86', { id: 86, code: 'GI', code2: 'GIB', displayValue: 'Gibraltar', description: 'Gibraltar', isReciprocity: false, sortOrder: 425, active: true });
        this._dictionary.add('87', { id: 87, code: 'GR', code2: 'GRC', displayValue: 'Greece', description: 'Greece', isReciprocity: false, sortOrder: 430, active: true });
        this._dictionary.add('88', { id: 88, code: 'GL', code2: 'GRL', displayValue: 'Greenland', description: 'Greenland', isReciprocity: false, sortOrder: 435, active: true });
        this._dictionary.add('89', { id: 89, code: 'GD', code2: 'GRD', displayValue: 'Grenada', description: 'Grenada', isReciprocity: false, sortOrder: 440, active: true });
        this._dictionary.add('90', { id: 90, code: 'GP', code2: 'GLP', displayValue: 'Guadeloupe', description: 'Guadeloupe', isReciprocity: false, sortOrder: 445, active: true });
        this._dictionary.add('256', { id: 256, code: 'GU', code2: 'GUM', displayValue: 'Guam', description: 'Guam', isReciprocity: false, sortOrder: 447, active: true });
        this._dictionary.add('92', { id: 92, code: 'GT', code2: 'GTM', displayValue: 'Guatemala', description: 'Guatemala', isReciprocity: false, sortOrder: 450, active: true });
        this._dictionary.add('93', { id: 93, code: 'GG', code2: 'GGY', displayValue: 'Guernsey', description: 'Guernsey', isReciprocity: false, sortOrder: 455, active: true });
        this._dictionary.add('94', { id: 94, code: 'GN', code2: 'GIN', displayValue: 'Guinea', description: 'Guinea', isReciprocity: false, sortOrder: 460, active: true });
        this._dictionary.add('95', { id: 95, code: 'GW', code2: 'GNB', displayValue: 'Guinea Bissau', description: 'Guinea Bissau', isReciprocity: false, sortOrder: 465, active: true });
        this._dictionary.add('96', { id: 96, code: 'GY', code2: 'GUY', displayValue: 'Guyana', description: 'Guyana', isReciprocity: false, sortOrder: 470, active: true });
        this._dictionary.add('97', { id: 97, code: 'HT', code2: 'HTI', displayValue: 'Haiti', description: 'Haiti', isReciprocity: false, sortOrder: 475, active: true });
        this._dictionary.add('98', { id: 98, code: 'HM', code2: 'HMD', displayValue: 'Heard Island And McDonald Islands', description: 'Heard Island And McDonald Islands', isReciprocity: false, sortOrder: 480, active: true });
        this._dictionary.add('99', { id: 99, code: 'HN', code2: 'HND', displayValue: 'Honduras', description: 'Honduras', isReciprocity: false, sortOrder: 485, active: true });
        this._dictionary.add('100', { id: 100, code: 'HK', code2: 'HKG', displayValue: 'Hong Kong', description: 'Hong Kong', isReciprocity: false, sortOrder: 490, active: true });
        this._dictionary.add('101', { id: 101, code: 'HU', code2: 'HUN', displayValue: 'Hungary', description: 'Hungary', isReciprocity: false, sortOrder: 495, active: true });
        this._dictionary.add('102', { id: 102, code: 'IS', code2: 'ISL', displayValue: 'Iceland', description: 'Iceland', isReciprocity: false, sortOrder: 500, active: true });
        this._dictionary.add('103', { id: 103, code: 'IN', code2: 'IND', displayValue: 'India', description: 'India', isReciprocity: false, sortOrder: 505, active: true });
        this._dictionary.add('104', { id: 104, code: 'ID', code2: 'IDN', displayValue: 'Indonesia', description: 'Indonesia', isReciprocity: false, sortOrder: 510, active: true });
        this._dictionary.add('105', { id: 105, code: 'IR', code2: 'IRN', displayValue: 'Iran', description: 'Iran', isReciprocity: false, sortOrder: 515, active: true });
        this._dictionary.add('106', { id: 106, code: 'IQ', code2: 'IRQ', displayValue: 'Iraq', description: 'Iraq', isReciprocity: false, sortOrder: 520, active: true });
        this._dictionary.add('107', { id: 107, code: 'IE', code2: 'IRL', displayValue: 'Ireland', description: 'Ireland', isReciprocity: false, sortOrder: 525, active: true });
        this._dictionary.add('108', { id: 108, code: 'IM', code2: 'IMN', displayValue: 'Isle Of Man', description: 'Isle Of Man', isReciprocity: false, sortOrder: 530, active: true });
        this._dictionary.add('109', { id: 109, code: 'IL', code2: 'ISR', displayValue: 'Israel', description: 'Israel', isReciprocity: false, sortOrder: 535, active: true });
        this._dictionary.add('110', { id: 110, code: 'IT', code2: 'ITA', displayValue: 'Italy', description: 'Italy', isReciprocity: false, sortOrder: 540, active: true });
        this._dictionary.add('111', { id: 111, code: 'JM', code2: 'JAM', displayValue: 'Jamaica', description: 'Jamaica', isReciprocity: false, sortOrder: 545, active: true });
        this._dictionary.add('112', { id: 112, code: 'JP', code2: 'JPN', displayValue: 'Japan', description: 'Japan', isReciprocity: false, sortOrder: 550, active: true });
        this._dictionary.add('113', { id: 113, code: 'JE', code2: 'JEY', displayValue: 'Jersey', description: 'Jersey', isReciprocity: false, sortOrder: 555, active: true });
        this._dictionary.add('114', { id: 114, code: 'JO', code2: 'JOR', displayValue: 'Jordan', description: 'Jordan', isReciprocity: false, sortOrder: 560, active: true });
        this._dictionary.add('115', { id: 115, code: 'KZ', code2: 'KAZ', displayValue: 'Kazakhstan', description: 'Kazakhstan', isReciprocity: false, sortOrder: 565, active: true });
        this._dictionary.add('116', { id: 116, code: 'KE', code2: 'KEN', displayValue: 'Kenya', description: 'Kenya', isReciprocity: false, sortOrder: 570, active: true });
        this._dictionary.add('117', { id: 117, code: 'KI', code2: 'KIR', displayValue: 'Kiribati', description: 'Kiribati', isReciprocity: false, sortOrder: 575, active: true });
        this._dictionary.add('118', { id: 118, code: 'KP', code2: 'PRK', displayValue: 'Korea (Democratic People\'s Republic Of)', description: 'Korea (Democratic People\'s Republic Of)', isReciprocity: false, sortOrder: 580, active: true });
        this._dictionary.add('119', { id: 119, code: 'KR', code2: 'KOR', displayValue: 'Korea (Republic Of)', description: 'Korea (Republic Of)', isReciprocity: false, sortOrder: 585, active: true });
        this._dictionary.add('120', { id: 120, code: 'KW', code2: 'KWT', displayValue: 'Kuwait', description: 'Kuwait', isReciprocity: false, sortOrder: 590, active: true });
        this._dictionary.add('121', { id: 121, code: 'KG', code2: 'KGZ', displayValue: 'Kyrgyzstan', description: 'Kyrgyzstan', isReciprocity: false, sortOrder: 595, active: true });
        this._dictionary.add('122', { id: 122, code: 'LA', code2: 'LAO', displayValue: 'Laos', description: 'Laos', isReciprocity: false, sortOrder: 600, active: true });
        this._dictionary.add('123', { id: 123, code: 'LV', code2: 'LVA', displayValue: 'Latvia', description: 'Latvia', isReciprocity: false, sortOrder: 605, active: true });
        this._dictionary.add('124', { id: 124, code: 'LB', code2: 'LBN', displayValue: 'Lebanon', description: 'Lebanon', isReciprocity: false, sortOrder: 610, active: true });
        this._dictionary.add('125', { id: 125, code: 'LS', code2: 'LSO', displayValue: 'Lesotho', description: 'Lesotho', isReciprocity: false, sortOrder: 615, active: true });
        this._dictionary.add('126', { id: 126, code: 'LR', code2: 'LBR', displayValue: 'Liberia', description: 'Liberia', isReciprocity: false, sortOrder: 620, active: true });
        this._dictionary.add('127', { id: 127, code: 'LY', code2: 'LBY', displayValue: 'Libya', description: 'Libya', isReciprocity: false, sortOrder: 625, active: true });
        this._dictionary.add('128', { id: 128, code: 'LI', code2: 'LIE', displayValue: 'Liechtenstein', description: 'Liechtenstein', isReciprocity: false, sortOrder: 630, active: true });
        this._dictionary.add('129', { id: 129, code: 'LT', code2: 'LTU', displayValue: 'Lithuania', description: 'Lithuania', isReciprocity: false, sortOrder: 635, active: true });
        this._dictionary.add('130', { id: 130, code: 'LU', code2: 'LUX', displayValue: 'Luxembourg', description: 'Luxembourg', isReciprocity: false, sortOrder: 640, active: true });
        this._dictionary.add('131', { id: 131, code: 'MO', code2: 'MAC', displayValue: 'Macao', description: 'Macao', isReciprocity: false, sortOrder: 645, active: true });
        this._dictionary.add('132', { id: 132, code: 'MK', code2: 'MKD', displayValue: 'Macedonia', description: 'Macedonia', isReciprocity: false, sortOrder: 650, active: true });
        this._dictionary.add('133', { id: 133, code: 'MG', code2: 'MDG', displayValue: 'Madagascar', description: 'Madagascar', isReciprocity: false, sortOrder: 655, active: true });
        this._dictionary.add('134', { id: 134, code: 'MW', code2: 'MWI', displayValue: 'Malawi', description: 'Malawi', isReciprocity: false, sortOrder: 660, active: true });
        this._dictionary.add('135', { id: 135, code: 'MY', code2: 'MYS', displayValue: 'Malaysia', description: 'Malaysia', isReciprocity: false, sortOrder: 665, active: true });
        this._dictionary.add('136', { id: 136, code: 'MV', code2: 'MDV', displayValue: 'Maldives', description: 'Maldives', isReciprocity: false, sortOrder: 670, active: true });
        this._dictionary.add('137', { id: 137, code: 'ML', code2: 'MLI', displayValue: 'Mali', description: 'Mali', isReciprocity: false, sortOrder: 675, active: true });
        this._dictionary.add('138', { id: 138, code: 'MT', code2: 'MLT', displayValue: 'Malta', description: 'Malta', isReciprocity: false, sortOrder: 680, active: true });
        this._dictionary.add('257', { id: 257, code: 'MH', code2: 'MHL', displayValue: 'Marshall Islands', description: 'Marshall Islands', isReciprocity: false, sortOrder: 682, active: true });
        this._dictionary.add('140', { id: 140, code: 'MQ', code2: 'MTQ', displayValue: 'Martinique', description: 'Martinique', isReciprocity: false, sortOrder: 685, active: true });
        this._dictionary.add('141', { id: 141, code: 'MR', code2: 'MRT', displayValue: 'Mauritania', description: 'Mauritania', isReciprocity: false, sortOrder: 690, active: true });
        this._dictionary.add('142', { id: 142, code: 'MU', code2: 'MUS', displayValue: 'Mauritius', description: 'Mauritius', isReciprocity: false, sortOrder: 695, active: true });
        this._dictionary.add('143', { id: 143, code: 'YT', code2: 'MYT', displayValue: 'Mayotte', description: 'Mayotte', isReciprocity: false, sortOrder: 700, active: true });
        this._dictionary.add('144', { id: 144, code: 'MX', code2: 'MEX', displayValue: 'Mexico', description: 'Mexico', isReciprocity: false, sortOrder: 705, active: true });
        this._dictionary.add('146', { id: 146, code: 'MD', code2: 'MDA', displayValue: 'Moldova', description: 'Moldova', isReciprocity: false, sortOrder: 710, active: true });
        this._dictionary.add('147', { id: 147, code: 'MC', code2: 'MCO', displayValue: 'Monaco', description: 'Monaco', isReciprocity: false, sortOrder: 715, active: true });
        this._dictionary.add('148', { id: 148, code: 'MN', code2: 'MNG', displayValue: 'Mongolia', description: 'Mongolia', isReciprocity: false, sortOrder: 720, active: true });
        this._dictionary.add('149', { id: 149, code: 'ME', code2: 'MNE', displayValue: 'Montenegro', description: 'Montenegro', isReciprocity: false, sortOrder: 725, active: true });
        this._dictionary.add('150', { id: 150, code: 'MS', code2: 'MSR', displayValue: 'Montserrat', description: 'Montserrat', isReciprocity: false, sortOrder: 730, active: true });
        this._dictionary.add('151', { id: 151, code: 'MA', code2: 'MAR', displayValue: 'Morocco', description: 'Morocco', isReciprocity: false, sortOrder: 735, active: true });
        this._dictionary.add('152', { id: 152, code: 'MZ', code2: 'MOZ', displayValue: 'Mozambique', description: 'Mozambique', isReciprocity: false, sortOrder: 740, active: true });
        this._dictionary.add('153', { id: 153, code: 'MM', code2: 'MMR', displayValue: 'Myanmar', description: 'Myanmar', isReciprocity: false, sortOrder: 745, active: true });
        this._dictionary.add('154', { id: 154, code: 'NA', code2: 'NAM', displayValue: 'Namibia', description: 'Namibia', isReciprocity: false, sortOrder: 750, active: true });
        this._dictionary.add('155', { id: 155, code: 'NR', code2: 'NRU', displayValue: 'Nauru', description: 'Nauru', isReciprocity: false, sortOrder: 755, active: true });
        this._dictionary.add('156', { id: 156, code: 'NP', code2: 'NPL', displayValue: 'Nepal', description: 'Nepal', isReciprocity: false, sortOrder: 760, active: true });
        this._dictionary.add('157', { id: 157, code: 'NL', code2: 'NLD', displayValue: 'Netherlands', description: 'Netherlands', isReciprocity: false, sortOrder: 765, active: true });
        this._dictionary.add('158', { id: 158, code: 'NC', code2: 'NCL', displayValue: 'New Caledonia', description: 'New Caledonia', isReciprocity: false, sortOrder: 770, active: true });
        this._dictionary.add('159', { id: 159, code: 'NZ', code2: 'NZL', displayValue: 'New Zealand', description: 'New Zealand', isReciprocity: false, sortOrder: 775, active: true });
        this._dictionary.add('160', { id: 160, code: 'NI', code2: 'NIC', displayValue: 'Nicaragua', description: 'Nicaragua', isReciprocity: false, sortOrder: 780, active: true });
        this._dictionary.add('161', { id: 161, code: 'NE', code2: 'NER', displayValue: 'Niger', description: 'Niger', isReciprocity: false, sortOrder: 785, active: true });
        this._dictionary.add('162', { id: 162, code: 'NG', code2: 'NGA', displayValue: 'Nigeria', description: 'Nigeria', isReciprocity: false, sortOrder: 790, active: true });
        this._dictionary.add('163', { id: 163, code: 'NU', code2: 'NIU', displayValue: 'Niue', description: 'Niue', isReciprocity: false, sortOrder: 795, active: true });
        this._dictionary.add('164', { id: 164, code: 'NF', code2: 'NFK', displayValue: 'Norfolk Island', description: 'Norfolk Island', isReciprocity: false, sortOrder: 800, active: true });
        this._dictionary.add('258', { id: 258, code: 'MP', code2: 'MNP', displayValue: 'Northern Mariana Island', description: 'Northern Mariana Island', isReciprocity: false, sortOrder: 802, active: true });
        this._dictionary.add('166', { id: 166, code: 'NO', code2: 'NOR', displayValue: 'Norway', description: 'Norway', isReciprocity: false, sortOrder: 805, active: true });
        this._dictionary.add('167', { id: 167, code: 'OM', code2: 'OMN', displayValue: 'Oman', description: 'Oman', isReciprocity: false, sortOrder: 810, active: true });
        this._dictionary.add('168', { id: 168, code: 'PK', code2: 'PAK', displayValue: 'Pakistan', description: 'Pakistan', isReciprocity: false, sortOrder: 815, active: true });
        this._dictionary.add('259', { id: 259, code: 'PW', code2: 'PLW', displayValue: 'Palau', description: 'Palau', isReciprocity: false, sortOrder: 817, active: true });
        this._dictionary.add('170', { id: 170, code: 'PS', code2: 'PSE', displayValue: 'Palestine', description: 'Palestine', isReciprocity: false, sortOrder: 820, active: true });
        this._dictionary.add('171', { id: 171, code: 'PA', code2: 'PAN', displayValue: 'Panama', description: 'Panama', isReciprocity: false, sortOrder: 825, active: true });
        this._dictionary.add('172', { id: 172, code: 'PG', code2: 'PNG', displayValue: 'Papua New Guinea', description: 'Papua New Guinea', isReciprocity: false, sortOrder: 830, active: true });
        this._dictionary.add('173', { id: 173, code: 'PY', code2: 'PRY', displayValue: 'Paraguay', description: 'Paraguay', isReciprocity: false, sortOrder: 835, active: true });
        this._dictionary.add('174', { id: 174, code: 'PE', code2: 'PER', displayValue: 'Peru', description: 'Peru', isReciprocity: false, sortOrder: 840, active: true });
        this._dictionary.add('175', { id: 175, code: 'PH', code2: 'PHL', displayValue: 'Philippines Island', description: 'Philippines Island', isReciprocity: false, sortOrder: 845, active: true });
        this._dictionary.add('176', { id: 176, code: 'PN', code2: 'PCN', displayValue: 'Pitcairn', description: 'Pitcairn', isReciprocity: false, sortOrder: 850, active: true });
        this._dictionary.add('177', { id: 177, code: 'PL', code2: 'POL', displayValue: 'Poland', description: 'Poland', isReciprocity: false, sortOrder: 855, active: true });
        this._dictionary.add('178', { id: 178, code: 'PT', code2: 'PRT', displayValue: 'Portugal', description: 'Portugal', isReciprocity: false, sortOrder: 860, active: true });
        this._dictionary.add('260', { id: 260, code: 'PR', code2: 'PRI', displayValue: 'Puerto Rico', description: 'Puerto Rico', isReciprocity: false, sortOrder: 862, active: true });
        this._dictionary.add('180', { id: 180, code: 'QA', code2: 'QAT', displayValue: 'Qatar', description: 'Qatar', isReciprocity: false, sortOrder: 865, active: true });
        this._dictionary.add('181', { id: 181, code: 'RE', code2: 'REU', displayValue: 'Reunion', description: 'Reunion', isReciprocity: false, sortOrder: 870, active: true });
        this._dictionary.add('182', { id: 182, code: 'RO', code2: 'ROU', displayValue: 'Romania', description: 'Romania', isReciprocity: false, sortOrder: 875, active: true });
        this._dictionary.add('183', { id: 183, code: 'RU', code2: 'RUS', displayValue: 'Russia', description: 'Russia', isReciprocity: false, sortOrder: 880, active: true });
        this._dictionary.add('184', { id: 184, code: 'RW', code2: 'RWA', displayValue: 'Rwanda', description: 'Rwanda', isReciprocity: false, sortOrder: 885, active: true });
        this._dictionary.add('185', { id: 185, code: 'BL', code2: 'BLM', displayValue: 'Saint Barthelemy', description: 'Saint Barthelemy', isReciprocity: false, sortOrder: 890, active: true });
        this._dictionary.add('186', { id: 186, code: 'SH', code2: 'SHN', displayValue: 'Saint Helena', description: 'Saint Helena', isReciprocity: false, sortOrder: 895, active: true });
        this._dictionary.add('187', { id: 187, code: 'KN', code2: 'KNA', displayValue: 'Saint Kitts And Nevis', description: 'Saint Kitts And Nevis', isReciprocity: false, sortOrder: 900, active: true });
        this._dictionary.add('188', { id: 188, code: 'MF', code2: 'MAF', displayValue: 'Saint Martin (French Part)', description: 'Saint Martin (French Part)', isReciprocity: false, sortOrder: 905, active: true });
        this._dictionary.add('189', { id: 189, code: 'PM', code2: 'SPM', displayValue: 'Saint Pierre And Miquelon', description: 'Saint Pierre And Miquelon', isReciprocity: false, sortOrder: 910, active: true });
        this._dictionary.add('190', { id: 190, code: 'SM', code2: 'SMR', displayValue: 'San Marino', description: 'San Marino', isReciprocity: false, sortOrder: 915, active: true });
        this._dictionary.add('191', { id: 191, code: 'ST', code2: 'STP', displayValue: 'Sao Tome And Principe', description: 'Sao Tome And Principe', isReciprocity: false, sortOrder: 920, active: true });
        this._dictionary.add('192', { id: 192, code: 'SA', code2: 'SAU', displayValue: 'Saudi Arabia', description: 'Saudi Arabia', isReciprocity: false, sortOrder: 925, active: true });
        this._dictionary.add('193', { id: 193, code: 'SN', code2: 'SEN', displayValue: 'Senegal', description: 'Senegal', isReciprocity: false, sortOrder: 930, active: true });
        this._dictionary.add('194', { id: 194, code: 'RS', code2: 'SRB', displayValue: 'Serbia', description: 'Serbia', isReciprocity: false, sortOrder: 935, active: true });
        this._dictionary.add('195', { id: 195, code: 'SC', code2: 'SYC', displayValue: 'Seychelles', description: 'Seychelles', isReciprocity: false, sortOrder: 940, active: true });
        this._dictionary.add('196', { id: 196, code: 'SL', code2: 'SLE', displayValue: 'Sierra Leone', description: 'Sierra Leone', isReciprocity: false, sortOrder: 945, active: true });
        this._dictionary.add('197', { id: 197, code: 'SG', code2: 'SGP', displayValue: 'Singapore', description: 'Singapore', isReciprocity: false, sortOrder: 950, active: true });
        this._dictionary.add('198', { id: 198, code: 'SX', code2: 'SXM', displayValue: 'Sint Maarten (Dutch Part)', description: 'Sint Maarten (Dutch Part)', isReciprocity: false, sortOrder: 955, active: true });
        this._dictionary.add('199', { id: 199, code: 'SK', code2: 'SVK', displayValue: 'Slovakia', description: 'Slovakia', isReciprocity: false, sortOrder: 960, active: true });
        this._dictionary.add('200', { id: 200, code: 'SI', code2: 'SVN', displayValue: 'Slovenia', description: 'Slovenia', isReciprocity: false, sortOrder: 965, active: true });
        this._dictionary.add('201', { id: 201, code: 'SB', code2: 'SLB', displayValue: 'Solomon Islands', description: 'Solomon Islands', isReciprocity: false, sortOrder: 970, active: true });
        this._dictionary.add('202', { id: 202, code: 'SO', code2: 'SOM', displayValue: 'Somalia', description: 'Somalia', isReciprocity: false, sortOrder: 975, active: true });
        this._dictionary.add('203', { id: 203, code: 'ZA', code2: 'ZAF', displayValue: 'South Africa', description: 'South Africa', isReciprocity: false, sortOrder: 980, active: true });
        this._dictionary.add('204', { id: 204, code: 'GS', code2: 'SGS', displayValue: 'South Georgia And The South Sandwich Islands', description: 'South Georgia And The South Sandwich Islands', isReciprocity: false, sortOrder: 985, active: true });
        this._dictionary.add('205', { id: 205, code: 'SS', code2: 'SSD', displayValue: 'South Sudan', description: 'South Sudan', isReciprocity: false, sortOrder: 990, active: true });
        this._dictionary.add('206', { id: 206, code: 'ES', code2: 'ESP', displayValue: 'Spain', description: 'Spain', isReciprocity: false, sortOrder: 995, active: true });
        this._dictionary.add('207', { id: 207, code: 'LK', code2: 'LKA', displayValue: 'Sri Lanka', description: 'Sri Lanka', isReciprocity: false, sortOrder: 1000, active: true });
        this._dictionary.add('208', { id: 208, code: 'VC', code2: 'VCT', displayValue: 'St Vincent And The Grenadines', description: 'St Vincent And The Grenadines', isReciprocity: false, sortOrder: 1005, active: true });
        this._dictionary.add('209', { id: 209, code: 'LC', code2: 'LCA', displayValue: 'St. Lucia', description: 'St. Lucia', isReciprocity: false, sortOrder: 1010, active: true });
        this._dictionary.add('210', { id: 210, code: 'SD', code2: 'SDN', displayValue: 'Sudan', description: 'Sudan', isReciprocity: false, sortOrder: 1015, active: true });
        this._dictionary.add('211', { id: 211, code: 'SR', code2: 'SUR', displayValue: 'Suriname', description: 'Suriname', isReciprocity: false, sortOrder: 1020, active: true });
        this._dictionary.add('212', { id: 212, code: 'SJ', code2: 'SJM', displayValue: 'Svalbard And Jan Mayen', description: 'Svalbard And Jan Mayen', isReciprocity: false, sortOrder: 1025, active: true });
        this._dictionary.add('213', { id: 213, code: 'SZ', code2: 'SWZ', displayValue: 'Swaziland', description: 'Swaziland', isReciprocity: false, sortOrder: 1030, active: true });
        this._dictionary.add('214', { id: 214, code: 'SE', code2: 'SWE', displayValue: 'Sweden', description: 'Sweden', isReciprocity: false, sortOrder: 1035, active: true });
        this._dictionary.add('215', { id: 215, code: 'CH', code2: 'CHE', displayValue: 'Switzerland', description: 'Switzerland', isReciprocity: false, sortOrder: 1040, active: true });
        this._dictionary.add('216', { id: 216, code: 'SY', code2: 'SYR', displayValue: 'Syria', description: 'Syria', isReciprocity: false, sortOrder: 1045, active: true });
        this._dictionary.add('217', { id: 217, code: 'TW', code2: 'TWN', displayValue: 'Taiwan', description: 'Taiwan', isReciprocity: false, sortOrder: 1050, active: true });
        this._dictionary.add('218', { id: 218, code: 'TJ', code2: 'TJK', displayValue: 'Tajikistan', description: 'Tajikistan', isReciprocity: false, sortOrder: 1055, active: true });
        this._dictionary.add('219', { id: 219, code: 'TZ', code2: 'TZA', displayValue: 'Tanzania', description: 'Tanzania', isReciprocity: false, sortOrder: 1060, active: true });
        this._dictionary.add('220', { id: 220, code: 'TH', code2: 'THA', displayValue: 'Thailand', description: 'Thailand', isReciprocity: false, sortOrder: 1065, active: true });
        this._dictionary.add('221', { id: 221, code: 'TL', code2: 'TLS', displayValue: 'Timor-Leste', description: 'Timor-Leste', isReciprocity: false, sortOrder: 1070, active: true });
        this._dictionary.add('222', { id: 222, code: 'TG', code2: 'TGO', displayValue: 'Togo', description: 'Togo', isReciprocity: false, sortOrder: 1075, active: true });
        this._dictionary.add('223', { id: 223, code: 'TK', code2: 'TKL', displayValue: 'Tokelau', description: 'Tokelau', isReciprocity: false, sortOrder: 1080, active: true });
        this._dictionary.add('224', { id: 224, code: 'TO', code2: 'TON', displayValue: 'Tonga', description: 'Tonga', isReciprocity: false, sortOrder: 1085, active: true });
        this._dictionary.add('225', { id: 225, code: 'TN', code2: 'TUN', displayValue: 'Tunisia', description: 'Tunisia', isReciprocity: false, sortOrder: 1090, active: true });
        this._dictionary.add('226', { id: 226, code: 'TR', code2: 'TUR', displayValue: 'Turkey', description: 'Turkey', isReciprocity: false, sortOrder: 1095, active: true });
        this._dictionary.add('227', { id: 227, code: 'TM', code2: 'TKM', displayValue: 'Turkmenistan', description: 'Turkmenistan', isReciprocity: false, sortOrder: 1100, active: true });
        this._dictionary.add('228', { id: 228, code: 'TC', code2: 'TCA', displayValue: 'Turks And Caicos Islands', description: 'Turks And Caicos Islands', isReciprocity: false, sortOrder: 1105, active: true });
        this._dictionary.add('229', { id: 229, code: 'TV', code2: 'TUV', displayValue: 'Tuvalu', description: 'Tuvalu', isReciprocity: false, sortOrder: 1110, active: true });
        this._dictionary.add('230', { id: 230, code: 'UG', code2: 'UGA', displayValue: 'Uganda', description: 'Uganda', isReciprocity: false, sortOrder: 1115, active: true });
        this._dictionary.add('231', { id: 231, code: 'UA', code2: 'UKR', displayValue: 'Ukraine', description: 'Ukraine', isReciprocity: false, sortOrder: 1120, active: true });
        this._dictionary.add('232', { id: 232, code: 'AE', code2: 'ARE', displayValue: 'United Arab Emirates', description: 'United Arab Emirates', isReciprocity: false, sortOrder: 1125, active: true });
        this._dictionary.add('233', { id: 233, code: 'GB', code2: 'GBR', displayValue: 'United Kingdom', description: 'United Kingdom', isReciprocity: false, sortOrder: 1130, active: true });
        this._dictionary.add('236', { id: 236, code: 'UK', code2: 'UNK', displayValue: 'Unknown', description: 'Unknown', isReciprocity: false, sortOrder: 1135, active: true });
        this._dictionary.add('237', { id: 237, code: 'UY', code2: 'URY', displayValue: 'Uruguay', description: 'Uruguay', isReciprocity: false, sortOrder: 1140, active: true });
        this._dictionary.add('239', { id: 239, code: 'UZ', code2: 'UZB', displayValue: 'Uzbekistan', description: 'Uzbekistan', isReciprocity: false, sortOrder: 1145, active: true });
        this._dictionary.add('240', { id: 240, code: 'VU', code2: 'VUT', displayValue: 'Vanuatu', description: 'Vanuatu', isReciprocity: false, sortOrder: 1150, active: true });
        this._dictionary.add('241', { id: 241, code: 'VA', code2: 'VAT', displayValue: 'Vatican City', description: 'Vatican City', isReciprocity: false, sortOrder: 1155, active: true });
        this._dictionary.add('242', { id: 242, code: 'VE', code2: 'VEN', displayValue: 'Venezuela', description: 'Venezuela', isReciprocity: false, sortOrder: 1160, active: true });
        this._dictionary.add('243', { id: 243, code: 'VN', code2: 'VNM', displayValue: 'Vietnam', description: 'Vietnam', isReciprocity: false, sortOrder: 1165, active: true });
        this._dictionary.add('261', { id: 261, code: 'VI', code2: 'VIR', displayValue: 'Virgin Islands', description: 'Virgin Islands', isReciprocity: false, sortOrder: 1167, active: true });
        this._dictionary.add('244', { id: 244, code: 'WF', code2: 'WLF', displayValue: 'Wallis And Futuna', description: 'Wallis And Futuna', isReciprocity: false, sortOrder: 1170, active: true });
        this._dictionary.add('245', { id: 245, code: 'EH', code2: 'ESH', displayValue: 'Western Sahara', description: 'Western Sahara', isReciprocity: false, sortOrder: 1175, active: true });
        this._dictionary.add('246', { id: 246, code: 'WS', code2: 'WSM', displayValue: 'Western Samoa', description: 'Western Samoa', isReciprocity: false, sortOrder: 1180, active: true });
        this._dictionary.add('247', { id: 247, code: 'YE', code2: 'YEM', displayValue: 'Yemen', description: 'Yemen', isReciprocity: false, sortOrder: 1185, active: true });
        this._dictionary.add('248', { id: 248, code: 'ZM', code2: 'ZMB', displayValue: 'Zambia', description: 'Zambia', isReciprocity: false, sortOrder: 1190, active: true });
        this._dictionary.add('249', { id: 249, code: 'ZW', code2: 'ZWE', displayValue: 'Zimbabwe', description: 'Zimbabwe', isReciprocity: false, sortOrder: 1195, active: true });
        this._dictionary.add('253', { id: 253, code: 'UW', code2: 'UKN', displayValue: 'Unknown', description: 'Unknown', isReciprocity: false, sortOrder: 1200, active: false });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ICountry {
        return this._dictionary[id];
    }

    public FromCode(code: string): ICountry {
        var match = this._dictionary.getValues().filter(d => d.value == code);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ICountry[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ICountry[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ICountry[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
